var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback } from 'react';
import { presenceActions } from 'components/presence/actions/presenceActions';
import { templatesActions } from 'components/settings/actions/templates';
import { actions as telephonyActions } from 'components/telephony/actions/telephony';
import { actions as visibilityActions } from 'middleware/visibility/actions/visibility';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { bindActionToPromise } from 'utils/sagaApiGeneratorHelpers';
/** A hook that dispatches legacy actions for compatibility reasons. */
export function useDispatchLegacyActions() {
    const dispatch = useAppDispatch();
    const trigger = useCallback((user, _organization) => __awaiter(this, void 0, void 0, function* () {
        yield bindActionToPromise(dispatch, presenceActions.presenceGet)({ user_id: user.id });
        dispatch(presenceActions.presenceGetAll(user.id));
        dispatch(visibilityActions.visibilityStart());
        dispatch(presenceActions.presenceGetWorkloadSettings());
        dispatch(templatesActions.templatesListAll());
        dispatch(telephonyActions.telephonyGetDefaultNumber());
    }), [dispatch]);
    return trigger;
}
